import CallIcon from "@mui/icons-material/Call";
import DeviceUnknownIcon from "@mui/icons-material/DeviceUnknown";
import EmailIcon from "@mui/icons-material/Email";
import SmartphoneIcon from "@mui/icons-material/Smartphone";
import { useMemo } from "react";
import { useIconStyles } from "./hooks/useIconStyles";
import { CommunicationTypeEnum } from "../../../store/services/communicationService";

interface CommunicationIconProps {
  type?: CommunicationTypeEnum;
  isPrimary?: boolean;
  isSetByCustomer?: boolean;
}

export const CommunicationIcon = ({
  type,
  isPrimary,
  isSetByCustomer,
}: CommunicationIconProps) => {
  const iconClass = useIconStyles({ isPrimary, isSetByCustomer });

  const IconComponent = useMemo(() => {
    switch (type) {
      case CommunicationTypeEnum.Telefon:
        return CallIcon;
      case CommunicationTypeEnum.Mobiltelefon:
        return SmartphoneIcon;
      case CommunicationTypeEnum.Epost:
        return EmailIcon;
      default:
        return DeviceUnknownIcon;
    }
  }, [type]);

  return <IconComponent sx={iconClass} fontSize="small" />;
};
